import React from "react";

const NotFound = () => (
    <div>
        <h1>Not Found</h1>
        <p>This page doesn't exist.</p>
        <a href="/">Go to Home</a>
    </div>
);

export default NotFound;